import React from 'react';
import { useImage } from 'react-image';
import CONFIG from '../../../config';

interface IBackgroundImageProps {
  imageName: string;
  extension?: string;
  useOnlyFallback?: boolean;
  useFullpath?: boolean;
}

const BackgroundImage = ({
  imageName,
  extension,
  useOnlyFallback = false,
  useFullpath = false
}: IBackgroundImageProps) => {
  const originalSrc = !useFullpath
    ? require(`../../../assets/${imageName}${extension ? '.' + extension : ''}`)
    : imageName;
  const fallBackSrc = !useFullpath
    ? `${CONFIG.assetDirectory}${imageName}${extension ? '.' + extension : ''}`
    : imageName;
  const imgSrc =
    useOnlyFallback && process.env.NODE_ENV !== 'development'
      ? fallBackSrc
      : [originalSrc, fallBackSrc];

  const { src } = useImage({
    srcList: imgSrc,
    useSuspense: false
  });

  return src;
};

export default BackgroundImage;
